/** What a campaign card shows: name and discount, the date range, then the status footer. */
import { campaignDiscountLabel, campaignRelativeText } from '@bonsai/shared';
import { ChevronRight } from 'lucide-react';

import {
  formatCampaignShortDateTime,
  type CampaignListRow,
} from '../ticket-sales-campaigns-list-model';
import TicketSalesCampaignStatusPill from '../TicketSalesCampaignStatusPill';

export interface TicketSalesCampaignCardContentProps {
  row: CampaignListRow;
  now: Date;
  showChevron: boolean;
}

export function TicketSalesCampaignCardContent({
  row,
  now,
  showChevron,
}: TicketSalesCampaignCardContentProps) {
  const { campaign, status } = row;
  return (
    <>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
        <div
          style={{
            flex: 1,
            minWidth: 0,
            fontSize: 15,
            fontWeight: 800,
            color: 'var(--nb-ink)',
            lineHeight: 1.25,
          }}
        >
          {campaign.name}
        </div>
        <span
          className="nb-tabular"
          style={{
            flex: '0 0 auto',
            fontSize: 14,
            fontWeight: 800,
            color: 'var(--nb-primary-2)',
            whiteSpace: 'nowrap',
          }}
        >
          {campaignDiscountLabel(campaign)}
        </span>
      </div>
      <div
        className="nb-tabular"
        style={{ fontSize: 12.5, color: 'var(--nb-muted)', marginTop: 6 }}
      >
        {formatCampaignShortDateTime(campaign.startsAt)} →{' '}
        {formatCampaignShortDateTime(campaign.endsAt)}
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          marginTop: 10,
          paddingTop: 10,
          borderTop: '1px solid var(--nb-border)',
        }}
      >
        <TicketSalesCampaignStatusPill status={status} />
        <span style={{ flex: 1, fontSize: 11.5, color: 'var(--nb-subtle)' }}>
          {campaignRelativeText(campaign, now)}
        </span>
        {showChevron && <ChevronRight size={14} aria-hidden style={{ color: 'var(--nb-faint)' }} />}
      </div>
    </>
  );
}
